<template>
  <div>
    <!-- 列表视图 -->
    <a-row v-if="mode === 'list'" :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle" :bordered="false">
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleAdd" type="primary" icon="plus">新建页面</a-button>
            <span class="decor-tip">同类型页面仅可发布一个；保存后需重新发布才对顾客端生效</span>
          </div>
          <!-- table区域 -->
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading">
            <template slot="typeSlot" slot-scope="text">
              <a-tag :color="typeMeta[text] ? typeMeta[text].color : ''">
                {{ typeMeta[text] ? typeMeta[text].label : text }}
              </a-tag>
            </template>
            <template slot="statusSlot" slot-scope="text">
              <a-tag v-if="text === '1'" color="green">已发布</a-tag>
              <a-tag v-else>未编辑</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <a v-if="btnEnableList.indexOf(1)>-1" @click="handleEdit(record)">编辑</a>
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a-divider type="vertical" />
                <a-popconfirm v-if="record.published === '1'" title="撤回后顾客端将无法访问该页面，确定撤回吗？" @confirm="() => handleUnpublish(record)">
                  <a>撤回</a>
                </a-popconfirm>
                <a v-else @click="handlePublish(record)">发布</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除该页面吗？" @confirm="() => handleDelete(record)">
                  <a style="color: red">删除</a>
                </a-popconfirm>
              </template>
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <!-- 编辑器视图（页内切换，不走路由） -->
    <div v-else-if="editingPage">
      <decor-editor :page="editingPage" @back="onEditorBack"></decor-editor>
    </div>
    <!-- 新建页面弹窗 -->
    <div ref="container">
      <a-modal
        title="新建装修页面"
        :visible="addVisible"
        :confirmLoading="addSaving"
        :getContainer="() => $refs.container"
        :mask="isDesktop()"
        :maskClosable="false"
        @ok="submitAdd"
        @cancel="addVisible = false"
        cancelText="取消"
        okText="创建并编辑"
        style="top: 200px;">
        <a-form>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="页面类型">
            <a-select v-model="addForm.pageType" placeholder="请选择页面类型">
              <a-select-option value="MALL_HOME">商城首页</a-select-option>
              <a-select-option value="DINING_HOME">点餐首页</a-select-option>
              <a-select-option value="CUSTOM">自定义</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="页面名称">
            <a-input placeholder="请输入页面名称" v-model="addForm.name" allow-clear />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </div>
</template>
<script>
import DecorEditor from './DecorEditor'
import { decorList, decorAdd, decorDelete, decorPublish, decorUnpublish } from '@/api/plugin/dining'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

/**
 * 装修页面列表（Task 11）：页面 CRUD/发布/撤回；编辑为页内 v-if 切换到 DecorEditor
 */
export default {
  name: 'DecorPageList',
  mixins: [JeecgListMixin],
  components: {
    DecorEditor
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      urlPath: '/plugin/dining/decor',
      queryParam: {},
      mode: 'list',
      editingPage: null,
      typeMeta: {
        MALL_HOME: { label: '商城首页', color: 'blue' },
        DINING_HOME: { label: '点餐首页', color: 'green' },
        CUSTOM: { label: '自定义', color: 'orange' }
      },
      columns: [
        { title: '页面名称', dataIndex: 'name', width: 200, align: 'left' },
        { title: '类型', dataIndex: 'pageType', width: 130, align: 'center', scopedSlots: { customRender: 'typeSlot' } },
        { title: '状态', dataIndex: 'published', width: 100, align: 'center', scopedSlots: { customRender: 'statusSlot' } },
        { title: '更新时间', dataIndex: 'updateTime', align: 'center',
          customRender: (text) => this.formatTime(text) },
        { title: '操作', dataIndex: 'action', width: 200, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/dining/decor/list'
      },
      addVisible: false,
      addSaving: false,
      addForm: { pageType: undefined, name: '' }
    }
  },
  methods: {
    /** 覆写 mixin：decor/list 返回整页数组（页面少不分页），非 {rows,total} */
    loadData() {
      this.loading = true
      decorList().then((res) => {
        if (res.code === 200) {
          this.dataSource = res.data || []
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    formatTime(t) {
      if (!t) {
        return '-'
      }
      if (typeof t === 'number') {
        const d = new Date(t)
        const p = (n) => (n < 10 ? '0' + n : '' + n)
        return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
      }
      return String(t).replace('T', ' ').split('.')[0]
    },
    handleAdd() {
      this.addForm = { pageType: undefined, name: '' }
      this.addVisible = true
    },
    submitAdd() {
      if (!this.addForm.pageType) {
        this.$message.warning('请选择页面类型')
        return
      }
      if (!this.addForm.name || !this.addForm.name.trim()) {
        this.$message.warning('请输入页面名称')
        return
      }
      this.addSaving = true
      const form = { pageType: this.addForm.pageType, name: this.addForm.name.trim() }
      decorAdd(form).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.addVisible = false
          // 创建成功后直接进编辑器（返回列表时会重新加载）
          this.openEditor({ id: res.data, pageType: form.pageType, name: form.name, published: '0' })
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.addSaving = false
      })
    },
    handleEdit(record) {
      this.openEditor(record)
    },
    openEditor(record) {
      this.editingPage = record
      this.mode = 'edit'
    },
    onEditorBack() {
      this.mode = 'list'
      this.editingPage = null
      this.loadData()
    },
    handlePublish(record) {
      this.$confirm({
        title: '发布页面',
        content: '确定发布 "' + record.name + '" 吗？同类型已发布页面将被替换。',
        okText: '发布',
        cancelText: '取消',
        onOk: () => {
          return decorPublish(record.id).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.loadData()
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      }).catch(() => {})
    },
    handleUnpublish(record) {
      decorUnpublish(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleDelete(record) {
      this.$confirm({
        title: '删除页面',
        content: '确定删除 "' + record.name + '" 吗？删除后不可恢复。',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return decorDelete(record.id).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.loadData()
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.decor-tip { color: #999; font-size: 12px; margin-left: 12px; }
</style>
